import { doDrawImage2 } from "./doDrawImage2";

export function getBase64Image(img, highRes = false) {
  // Create an empty canvas element
  var canvas = document.createElement("canvas");

  const scale = highRes ? 3 : 1;
  canvas.width = img.width * scale;
  canvas.height = img.height * scale;
  console.log(scale);
  //img.getElement().setAttribute("crossOrigin", "anonymous");
  // Copy the image contents to the canvas
  var ctx = canvas.getContext("2d");
  ctx.save();
  ctx.scale(scale, scale);
  //  ctx.drawImage(img, 0, 0);
  doDrawImage2(ctx, img, 0, 0);

  // Get the data-URL formatted image
  // Firefox supports PNG and JPEG. You could check img.src to
  // guess the original format, but be aware the using "image/jpg"
  // will re-encode the image.
  var dataURL = canvas.toDataURL("image/png");
  ctx.restore();

  return dataURL;

  //return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
}
